export default __webpack_public_path__ + "static/media/aboutus.7f911a2f.jpg";